import * as React from "react";
import { View, StyleSheet, ImageBackground, Image, Text, useWindowDimensions, } from "react-native";
import NavBar from "./NavBar";
import TitleSection from "./TitleSection";
import PrinciplesCard from "./PrinciplesCard";
import Header from "./Header";
import Footer from "./Footer";
import "./Ecosystem.css"; // Import the CSS file

function MyComponent() {
  const { width } = useWindowDimensions();
  const isMobile = width < 991;
  const responsiveStyles = isMobile ? stylesMobile : stylesDesktop;
  return (
    <ImageBackground
      resizeMode="cover"
      source={{
        uri: "https://cdn.builder.io/api/v1/image/assets/TEMP/bf7af681e995ed8c3f4671bc93944e9eaba134dc?placeholderIfAbsent=true&apiKey=dc92873c1f1248208a6c2f605a864cfc",
      }}
      style={responsiveStyles.image1}
    >
      <View style={responsiveStyles.centeredContent}>
        {/* Our Goals Section */}
        <View style={responsiveStyles.row}>
          <View style={responsiveStyles.imageColumn}>
            <Image
              resizeMode="contain"
              source={{
                uri: "https://cdn.builder.io/api/v1/image/assets/TEMP/05cfebba4bb3c21e12da21b429669f4df2cb6996?placeholderIfAbsent=true&apiKey=dc92873c1f1248208a6c2f605a864cfc",
              }}
              style={responsiveStyles.image2}
            />
          </View>
          <View style={responsiveStyles.textContainer}>
            <Text style={responsiveStyles.sectionTitle}>Our Goals</Text>
            <Text style={responsiveStyles.sectionText}>
            <div className="text1">The <strong style={{ fontWeight: "800", fontFamily: "'Montserrat', sans-serif"  }}>KIY Ecosystem</strong> aims to establish a decentralized community with
              the ambitious goals of:</div>
              <ul style={responsiveStyles.ul}>
                <li style={responsiveStyles.li}><strong style={{ fontWeight: "1000", fontFamily: "'Montserrat', sans-serif"  }}>100 million high-quality Web3 users</strong></li>
                Attracting and retaining over{" "}
                <strong style={{ fontWeight: "1000", fontFamily: "'Montserrat', sans-serif" }}>100 million high-quality Web3 users</strong>
              </ul>
              <ul style={responsiveStyles.ul}>
                <li style={responsiveStyles.li}><strong style={{ fontWeight: "1000", fontFamily: "'Montserrat', sans-serif" }}>1,000 promising Web3 projects</strong></li>
                Curating and integrating <strong style={{ fontWeight: "1000", fontFamily: "'Montserrat', sans-serif" }}>1,000 promising Web3 projects</strong>
              </ul>{" "}
            </Text>
          </View>
        </View>

        {/* Ecosystem Components Section */}
        <View style={responsiveStyles.row}>
          <View style={responsiveStyles.imageColumn}>
            <Image
              resizeMode="contain"
              source={{
                uri: "https://cdn.builder.io/api/v1/image/assets/TEMP/00cbbbe12da8f2899b7f64cfde452a24c0652f8c?placeholderIfAbsent=true&apiKey=dc92873c1f1248208a6c2f605a864cfc",
              }}
              style={responsiveStyles.image2}
            />
          </View>
          <View style={responsiveStyles.textContainer}>
            <Text style={responsiveStyles.sectionTitle}>Ecosystem Components</Text>
            <Text style={responsiveStyles.sectionText}>
              <div className="text1">The ecosystem comprises two components:</div>
              <ul style={responsiveStyles.ul}>
                <li style={responsiveStyles.li}>KIY Loyal User Ecosystem (KLU)</li>
                Achieving <strong style={{ fontWeight: "1000", fontFamily: "'Montserrat', sans-serif" }}>100 million user retention</strong>
              </ul> 
              <ul style={responsiveStyles.ul}>
                <li style={responsiveStyles.li}>KIY Partnered Project Ecosystem (KPP)</li>
                Completing integration of <strong style={{ fontWeight: "1000", fontFamily: "'Montserrat', sans-serif" }}>1,000 projects</strong>
              </ul>{" "}
            </Text>
          </View>
        </View>

        <View style={responsiveStyles.view7}>
          <div className="titled">
            Through seamless integration <br className="responsive-br"/>via the KIY Security System
          </div>
          {/* <Text style={responsiveStyles.title}>
          </Text> */}
        </View>
        <View style={responsiveStyles.view8}>
          <Text style={responsiveStyles.viewText}>
            <strong style={{ fontWeight: "800", fontFamily: "Montserrat, sans-serif" }}>KLU</strong> and <strong style={{ fontWeight: "800", fontFamily: "Montserrat, sans-serif" }}  >KPP</strong> effectively create value bonds between users and projects:
            KLU continuously <br className="responsive-br"/>delivers verified, tier-managed premium users to KPP,
            while loyal KLU users receive <br className="responsive-br"/>exclusive airdrop token rewards from KPP
            projects – forming a virtuous cycle of user <br className="responsive-br"/>engagement and value
            circulation.
          </Text>
        </View>
        <Image
          resizeMode="contain"
          source={{
            uri: "https://cdn.builder.io/api/v1/image/assets/TEMP/67335474ad68b2d98d3d91d29510b0f2173f88db?placeholderIfAbsent=true&apiKey=dc92873c1f1248208a6c2f605a864cfc",
          }}
          style={responsiveStyles.image4}
        />
      </View>
      {/* New Component */}
      <>
        <View
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@latest/dist/tabler-icons.min.css"
        />
        <View
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;700&display=swap"
          rel="stylesheet"
        />
        <View style={responsiveStyles.view1}>
          <View>
            <div className="titled" style={{ marginBottom: "80px" }}>Web3 Security</div>
          </View>
          <View style={responsiveStyles.view6}>
            <View>
              <Text style={responsiveStyles.view10}>De-centralized Security</Text>
            </View>
            <View>
              <Text style={responsiveStyles.view13}>
                The security mechanism is deployed and managed by different personnel across  <br className="responsive-br"/>
                multiple locations, effectively preventing single-point attacks and internal <br className="responsive-br"/>
                breaches. This model features low deployment costs but imposes high costs on
                <br className="responsive-br"/>potential attackers.
              </Text>
            </View>
          </View>
          <View style={responsiveStyles.view6}>
            <View>
              <Text style={responsiveStyles.view10}>Self-sovereign Security</Text>
            </View>
            <View >
              <Text style={responsiveStyles.view13}>
                Users maintain complete autonomous control over security, with no reliance on <br className="responsive-br"/>
                third parties (including technical support services). The security solution must be <br className="responsive-br"/>
                intuitively understandable and easy to operate.
              </Text>
            </View>
          </View>
          <View style={responsiveStyles.view6}>
            <View>
              <Text style={responsiveStyles.view10}>User-centric Security</Text>
            </View>
            <View >
              <Text style={responsiveStyles.view13}>
                The security framework is user-initialized, deploying unified
                security policies <br className="responsive-br"/>across all products and services. "One person,
                one key" applies universally <br className="responsive-br"/>throughout the ecosystem. This
                single-key-per-user model simplifies security <br className="responsive-br"/>management while
                delivering seamless protection across the entire Web3 <br className="responsive-br"/>ecosystem.
                This user-oriented security paradigm both safeguards user <br className="responsive-br"/>sovereignty and resolves multi-system management complexities,
                establishing <br className="responsive-br"/>the security foundation for mass Web3 adoption.
              </Text>
            </View>
          </View>
        </View>
      </>
    </ImageBackground>
  );
}

function Ecosystem() {
  const { width } = useWindowDimensions();
  const isMobile = width < 991;
  const responsiveStyles = isMobile ? stylesMobile : stylesDesktop;
  return (
    <View style={responsiveStyles.container}>
      <ImageBackground
        source={{
          uri: "https://cdn.builder.io/api/v1/image/assets/TEMP/2f429943dd943d84e69104c0b48f1623bff7a70b?placeholderIfAbsent=true&apiKey=dc92873c1f1248208a6c2f605a864cfc",
        }}
        style={responsiveStyles.backgroundImage}
      >
        <Header />
        <View style={responsiveStyles.titleSectionWrapper}>
          <TitleSection  />
          <br className="responsive-br"/>
          <br/>
          <br />
          <PrinciplesCard />
        </View>
        <ImageBackground
          source={{
            uri: "https://cdn.builder.io/api/v1/image/assets/TEMP/bf7af681e995ed8c3f4671bc93944e9eaba134dc?placeholderIfAbsent=true&apiKey=dc92873c1f1248208a6c2f605a864cfc",
          }}
          style={responsiveStyles.image1}
        >
          <MyComponent />
        </ImageBackground>
      </ImageBackground>
      <Footer />
    </View>
  );
}
const stylesMobile = StyleSheet.create({
  container: {
    flex: 1, // Make the container take the full screen
    flexDirection: "column",
    position: "relative",
    alignItems: "center",
    fontFamily: "Montserrat, -apple-system, Roboto, Helvetica, sans-serif",
    paddingBottom: 20,
    width: "100%",
  },
  backgroundImage: {
    flex: 1,
    width: "100%", // Cover the full width
    height: "25%", // Cover the full height
    resizeMode: "cover", // Ensure the image scales properly
  },
  titleSectionWrapper: {
    marginTop: 60, // Add 40px distance from the Header
    alignItems: "center", // Center align the TitleSection
    justifyContent: "center",
  },
  
  image1: {
    flex: 1,
    width: "100%",
    height: "100%",
    resizeMode: "cover",
  },
  centeredContent: {
    alignItems: "center", // Center horizontally
    justifyContent: "center", 
    marginTop: 50,
  },  
  row: {
    flexDirection: "row",
    alignItems: "flex",
    justifyContent: "flex-start",
    width: "90%",
  },
  imageColumn: {
    width: "30%", // Fixed width for the image column
    marginRight: 20,
    marginTop: 0,

  },
  image2: {
    width: "100%" ,
    aspectRatio: 1, 
  },
  textContainer: {
    flex: 1,
      },
  sectionTitle: {
    fontSize: "20px",
    fontWeight: 800,
    marginBottom: 15,
    color: "white", // Make the title text white
    fontFamily: "'Montserrat', sans-serif",
  },
  sectionText: {
    fontSize: "12px",
    lineHeight: 23, // Reduce spacing to 2px (fontSize + 2px)
    color: "white", // Make the body text white
    fontFamily: "'Montserrat', sans-serif",
    marginBottom: 5,
  },
  sectionText1:{
    marginBottom: 5,
  },
  ul: {
    // marginVertical: 1,
    color: "white", // Ensure <ul> text is white
    fontFamily: "'Montserrat', sans-serif",
    marginLeft: -10,
    fontSize: "12px",
    marginBottom: 5
  },
  li: {
    // marginVertical: 2, 
    color: "white", // Ensure <li> text is white
    fontFamily: "'Montserrat', sans-serif",
    marginBottom: 3,
    fontWeight: 800,
    fontSize: "12px",
  },
  view7: {
    width: "90%", // Match the width of TitleSection
    maxWidth: "100%", // Ensure it is responsive
    marginVertical: 12, // Add spacing similar to the subtitle
    alignItems: "center", // Center content horizontally
    fontFamily: "'Montserrat',sans-serif",
    fontSize: 28,
    fontWeight: "300",
    lineHeight: "120%",
    letterSpacing: -0.16,
    color: "white", // Ensure text is white
    marginBottom: 12,
    fontFamily: "'Montserrat', sans-serif",
  },
  view8: {
    width: "85%", // Match the width of TitleSection
    marginVertical: 12, // Add spacing similar to the subtitle
    alignItems: "center", // Center content horizontally
    fontFamily: "'Montserrat',sans-serif",
    fontSize: 14,
    fontWeight: "300",
    lineHeight: "160%",
    color: "white", // Ensure text is white
    fontFamily: "'Montserrat', sans-serif",
  },
  viewText: {
    textAlign: "center", // Center the text
    color: "white", // Make the text white
    fontSize: 16, // Match the subtitle font size
    fontWeight: "300", // Match the subtitle font weight
    lineHeight: 22, // Match the subtitle line height
    fontFamily: "'Montserrat', sans-serif",
  },
  image4: {
    marginTop: 50, // Add spacing above the image
    width: "90%", // Set width to 70% of the page
    aspectRatio: 1, // Automatically adjust height based on width
    alignSelf: "center", // Center the image horizontally
    marginBottom: 50, // Add spacing below the image
  },
  title: {
    marginTop: 80, // Add spacing above the title
    fontSize: 40, // Match TitleSection title font size
    fontWeight: "700", // Match TitleSection title font weight
    lineHeight: 40, // Match TitleSection title line height
    letterSpacing: -1.2, // Match TitleSection title letter spacing
    color: "white", // Match TitleSection title color
    textAlign: "center", // Center the text
    fontFamily: "'Montserrat', sans-serif",
  },
  view1: {
    maxWidth: "100%",
    marginLeft: 0,
    marginRight: 0,
    width: "100%",
    minHeight: 856,
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 82,
    paddingRight: 20,
    paddingBottom: 82,
    paddingLeft: 20,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  view2: {
    fontFamily: "'Montserrat',sans-serif",
    fontSize: 40,
    fontWeight: "700",
    lineHeight: "100%",
    letterSpacing: -1.2,
    textAlign: "center",
    color: "white", // Ensure text is white
    marginBottom: 100,
    fontFamily: "'Montserrat', sans-serif",
  },
  view3: {
    maxWidth: 574,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 40,
    marginLeft: 0,
    textAlign: "center",
    fontFamily: "'Montserrat', sans-serif",
  },
  view4: {
    fontFamily: "'Montserrat',sans-serif",
    fontSize: 28,
    fontWeight: "300",
    lineHeight: "120%",
    letterSpacing: -0.16,
    color: "white", // Ensure text is white
    marginBottom: 12,
    textAlign: "center",
    fontFamily: "'Montserrat', sans-serif",
  },
  view5: {
    fontFamily: "'Montserrat',sans-serif",
    fontSize: 14,
    fontWeight: "300",
    lineHeight: "160%",
    color: "white", // Ensure text is white
    maxWidth: 574,
    textAlign: "center",
    marginBottom: 40,
    fontFamily: "'Montserrat', sans-serif",
  },
  view6: {
    maxWidth: "95%",
    marginTop: 0,
    marginRight: 0,
    marginBottom: 40,
    marginLeft: 0,
    textAlign: "center",
    fontFamily: "'Montserrat', sans-serif",
  },
  view9: {
    maxWidth: 574,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 40,
    marginLeft: 0,
    textAlign: "center",
    fontFamily: "'Montserrat', sans-serif",
  },
  view10: {
    fontFamily: "'Montserrat',sans-serif",
    fontSize: "20px",
    fontWeight: "500",
    lineHeight: "120%",
    letterSpacing: 0,
    color: "white", // Ensure text is white
    marginBottom: "15px",
    textAlign: "center",
    fontFamily: "'Montserrat', sans-serif",
  },
  view11: {
    fontFamily: "'Montserrat',sans-serif",
    fontSize: 14,
    fontWeight: "0",
    lineHeight: "160%",
    color: "white", // Ensure text is white
    maxWidth: 574,
    textAlign: "center",
    marginBottom: 40,
    fontFamily: "'Montserrat', sans-serif",
  },
  view12: {
    fontFamily: "'Montserrat',sans-serif",
    fontSize: 28,
    fontWeight: "300",
    lineHeight: "120%",
    letterSpacing: -0.16,
    color: "white", // Ensure text is white
    marginBottom: 12,
    textAlign: "center", // Center the text
    fontFamily: "'Montserrat', sans-serif",
  },
  view13: {
    fontFamily: "'Montserrat',sans-serif",
    fontSize: "12px",
    fontWeight: "100", // Set font weight to thin
    lineHeight: "160%",
    color: "white", // Ensure text is white
    width: "100%",
    textAlign: "center", // Center the text
    marginBottom: 60,
    letterSpacing: 1,
    fontFamily: "'Montserrat', sans-serif",
  },
});





const stylesDesktop = StyleSheet.create({
  container: {
    flex: 1, // Make the container take the full screen
    flexDirection: "column",
    position: "relative",
    alignItems: "center",
    fontFamily: "Montserrat, -apple-system, Roboto, Helvetica, sans-serif",
    paddingBottom: 20,
  },
  backgroundImage: {
    flex: 1,
    width: "100%", // Cover the full width
    height: "25%", // Cover the full height
    resizeMode: "cover", // Ensure the image scales properly
  },
  titleSectionWrapper: {
    marginTop: 60, // Add 40px distance from the Header
    alignItems: "center", // Center align the TitleSection
    justifyContent: "center",
  },
  principlesCard: {
    marginTop: 800, 
  },
  
  image1: {
    flex: 1,
    width: "100%",
    height: "100%",
    resizeMode: "cover",
  },
  centeredContent: {
    alignItems: "center", // Center horizontally
    justifyContent: "center", // Center vertically
    marginTop: 50, // Add 80px distance from the top of image1
  },
  row: {
    flexDirection: "row", // Align items horizontally
    alignItems: "flex",
    justifyContent: "center", // Center the row itself
    width: "60%",
    marginVertical: 40,
  },
  imageColumn: {
    width: 170, // Fixed width for the image column
    marginRight: 80, // Add spacing between the image and text
  },
  image2: {
    width: 170,
    height: 170,
    
  },
  textContainer: {
    flex: 1,
      },
  sectionTitle: {
    fontSize: 35,
    fontWeight: 800,
    marginBottom: 15,
    color: "white", // Make the title text white
    fontFamily: "'Montserrat', sans-serif",
  },
  sectionText: {
    fontSize: 14,
    lineHeight: 23, // Reduce spacing to 2px (fontSize + 2px)
    color: "white", // Make the body text white
    fontFamily: "'Montserrat', sans-serif",
    marginBottom: 5,
  },
  sectionText1:{
    marginBottom: 5,
  },
  ul: {
    // marginVertical: 1,
    color: "white", // Ensure <ul> text is white
    fontFamily: "'Montserrat', sans-serif",
    marginLeft: -10,
    fontSize: 14,
    marginBottom: 5
  },
  li: {
    // marginVertical: 2, 
    color: "white", // Ensure <li> text is white
    fontFamily: "'Montserrat', sans-serif",
    marginBottom: 3,
    fontWeight: 800,
    
  },
  view7: {
    width: "80%", // Match the width of TitleSection
    maxWidth: "100%", // Ensure it is responsive
    marginVertical: 12, // Add spacing similar to the subtitle
    alignItems: "center", // Center content horizontally
    fontFamily: "'Montserrat',sans-serif",
    fontSize: 28,
    fontWeight: "300",
    lineHeight: "120%",
    letterSpacing: -0.16,
    color: "white", // Ensure text is white
    marginBottom: 12,
    fontFamily: "'Montserrat', sans-serif",
  },
  view8: {
    width: "54%", // Match the width of TitleSection
    marginVertical: 12, // Add spacing similar to the subtitle
    alignItems: "center", // Center content horizontally
    fontFamily: "'Montserrat',sans-serif",
    fontSize: 14,
    fontWeight: "300",
    lineHeight: "160%",
    color: "white", // Ensure text is white
    fontFamily: "'Montserrat', sans-serif",
  },
  viewText: {
    textAlign: "center", // Center the text
    color: "white", // Make the text white
    fontSize: 16, // Match the subtitle font size
    fontWeight: "300", // Match the subtitle font weight
    lineHeight: 22, // Match the subtitle line height
    fontFamily: "'Montserrat', sans-serif",
  },
  image4: {
    marginTop: 50, // Add spacing above the image
    width: "50%", // Set width to 70% of the page
    aspectRatio: 1, // Automatically adjust height based on width
    alignSelf: "center", // Center the image horizontally
    marginBottom: 50, // Add spacing below the image
  },
  title: {
    marginTop: 80, // Add spacing above the title
    fontSize: 40, // Match TitleSection title font size
    fontWeight: "700", // Match TitleSection title font weight
    lineHeight: 40, // Match TitleSection title line height
    letterSpacing: -1.2, // Match TitleSection title letter spacing
    color: "white", // Match TitleSection title color
    textAlign: "center", // Center the text
    fontFamily: "'Montserrat', sans-serif",
  },
  view1: {
    maxWidth: "100%",
    marginLeft: 0,
    marginRight: 0,
    width: "100%",
    minHeight: 856,
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 82,
    paddingRight: 20,
    paddingBottom: 82,
    paddingLeft: 20,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  view2: {
    fontFamily: "'Montserrat',sans-serif",
    fontSize: 40,
    fontWeight: "700",
    lineHeight: "100%",
    letterSpacing: -1.2,
    textAlign: "center",
    color: "white", // Ensure text is white
    marginBottom: 100,
    fontFamily: "'Montserrat', sans-serif",
  },
  view3: {
    maxWidth: 574,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 40,
    marginLeft: 0,
    textAlign: "center",
    fontFamily: "'Montserrat', sans-serif",
  },
  view4: {
    fontFamily: "'Montserrat',sans-serif",
    fontSize: 28,
    fontWeight: "300",
    lineHeight: "120%",
    letterSpacing: -0.16,
    color: "white", // Ensure text is white
    marginBottom: 12,
    textAlign: "center",
    fontFamily: "'Montserrat', sans-serif",
  },
  view5: {
    fontFamily: "'Montserrat',sans-serif",
    fontSize: 14,
    fontWeight: "300",
    lineHeight: "160%",
    color: "white", // Ensure text is white
    maxWidth: 574,
    textAlign: "center",
    marginBottom: 40,
    fontFamily: "'Montserrat', sans-serif",
  },
  view6: {
    maxWidth: "60%",
    marginTop: 0,
    marginRight: 0,
    marginBottom: 40,
    marginLeft: 0,
    textAlign: "center",
    fontFamily: "'Montserrat', sans-serif",
  },
  view9: {
    maxWidth: 574,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 40,
    marginLeft: 0,
    textAlign: "center",
    fontFamily: "'Montserrat', sans-serif",
  },
  view10: {
    fontFamily: "'Montserrat',sans-serif",
    fontSize: 35,
    fontWeight: "500",
    lineHeight: "120%",
    letterSpacing: -0.16,
    color: "white", // Ensure text is white
    marginBottom: 20,
    textAlign: "center",
    fontFamily: "'Montserrat', sans-serif",
  },
  view11: {
    fontFamily: "'Montserrat',sans-serif",
    fontSize: 14,
    fontWeight: "0",
    lineHeight: "160%",
    color: "white", // Ensure text is white
    maxWidth: 574,
    textAlign: "center",
    marginBottom: 40,
    fontFamily: "'Montserrat', sans-serif",
  },
  view12: {
    fontFamily: "'Montserrat',sans-serif",
    fontSize: 28,
    fontWeight: "300",
    lineHeight: "120%",
    letterSpacing: -0.16,
    color: "white", // Ensure text is white
    marginBottom: 12,
    textAlign: "center", // Center the text
    fontFamily: "'Montserrat', sans-serif",
  },
  view13: {
    fontFamily: "'Montserrat',sans-serif",
    fontSize: 16,
    fontWeight: "100", // Set font weight to thin
    lineHeight: "160%",
    color: "white", // Ensure text is white
    width: "100%",
    textAlign: "center", // Center the text
    marginBottom: 60,
    letterSpacing: 1,
    fontFamily: "'Montserrat', sans-serif",
  },
});

export default Ecosystem;
